import type { ClientPortalPermissionKey } from '~/lib/clientPortalPermissions';
import type { NotificationEntityType, NotificationEventType, NotificationSeverity, NotificationSurface, TeamMember } from '~/types/models';

export type NotificationRecipientSpec =
    | { type: 'tenant_user_ids'; userIds: string[] }
    | { type: 'tenant_roles'; roles: TeamMember['role'][] }
    | { type: 'tenant_all_members' }
    | {
        type: 'portal_access';
        clientId: string;
        projectId?: string;
        permission?: ClientPortalPermissionKey;
    };

export type DispatchNotificationPayload = {
    tenantId: string;
    surface: NotificationSurface;
    eventType: NotificationEventType;
    title: string;
    body: string;
    recipients: NotificationRecipientSpec[];
    severity?: NotificationSeverity;
    clientId?: string;
    projectId?: string;
    entityType?: NotificationEntityType;
    entityId?: string;
    actionPath?: string;
    actionLabel?: string;
    actorId?: string;
    actorName?: string;
    actorAvatarURL?: string;
    dedupeKey?: string;
    dedupeWindowHours?: number;
    email?: {
        template: 'approval_requested' | 'task_response_requested' | 'task_response_reminder' | 'message_response_reminder' | 'quote_ready' | 'invoice_ready' | 'invoice_due' | 'contract_ready';
        subject?: string;
        actionLink?: string;
        actionLabel?: string;
        workspaceName?: string;
        clientName?: string;
        recipientName?: string;
        projectName?: string;
        projectSummary?: string;
        periodLabel?: string;
        highlights?: string[];
        documentTitle?: string;
        documentNumber?: string;
        amountTotal?: number;
        currency?: string;
        dueDate?: string;
        expiryDate?: string;
    };
};

export async function dispatchNotification(payload: DispatchNotificationPayload): Promise<void> {
    const { $auth } = useNuxtApp();
    const authUser = $auth.currentUser;

    if (!authUser?.uid) {
        return;
    }

    const token = await authUser.getIdToken();

    const response = await $fetch<{ delivered?: number }>('/api/notifications/dispatch', {
        method: 'POST',
        headers: {
            authorization: `Bearer ${token}`,
        },
        body: payload,
    });

    console.info('[notifications.dispatch] Dispatch completed', {
        eventType: payload.eventType,
        surface: payload.surface,
        tenantId: payload.tenantId,
        delivered: Number(response?.delivered || 0),
    });
}
